import * as React from "react";
import styled from "styled-components";
import VideoComponent from "common/components/videoPlayer";
import EmbeddedVideo from "common/components/embeddedVideo";
import ImageComponent from "common/components/imageHolder";
import { px2rem } from "common/helpers/rem";

const Wrapper = styled.div`
  width: 100%;
  max-width: 100%;
`;

const SubWrapper = styled.div`
  max-height: inherit;
  position: relative;
`;

const Container = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;

interface IProps {
  resource: Vingle.IResource | null;
  className?: string;
}

class Media extends React.PureComponent<IProps> {
  public render() {
    const { resource, className } = this.props;
    if (!resource || resource.type === "og-object") {
      return null;
    }
    let media = null;
    switch (resource.type) {
      case "image":
        media = (
          <ImageComponent
            src={resource.data.url}
            height={resource.data.height}
            width={resource.data.width}
            previewColor={resource.data["preview-color"]}
            blurHash={resource.data.blur_hash}
          />
        );
        break;

      case "animated-image":
      case "video":
        media = <VideoComponent block={resource} />;
        break;

      case "embedded-video":
        media = <EmbeddedVideo block={resource.data} />;
        break;
    }

    return (
      <Wrapper
        className={className}
        style={{
          width: px2rem(resource.data.width),
        }}
      >
        <SubWrapper
          style={{
            paddingTop: `${(resource.data.height / resource.data.width) *
              100}%`,
          }}
        >
          <Container>{media}</Container>
        </SubWrapper>
      </Wrapper>
    );
  }
}

export default Media;
